import { decompress } from './decompress';
import { decrypt } from './decrypt';

/* istanbul ignore next */
export async function readSvtFile(file: ArrayBuffer): Promise<Uint8Array> {
  const decrypted = await decrypt(file);
  const decompressed = decompress(decrypted);
  return decompressed;
}
